import { BANNED_CHS } from "../constants";

/**
 * Takes list of objects and filters out those with a displayName field that is included in list of banned CHs
 * - NOTE: objects in chList must have a displayName field
 * @param {Object} chList
 * @returns {Object} filtered list of CHs
 */
export const removedBannedChs = (chList) =>
  chList.filter(
    ({ displayName }) => !BANNED_CHS.find(({ displayName: bannedDisplayName }) => displayName === bannedDisplayName)
  );
